import script from "./ServerIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__